import Vue from "vue";
import Router from "vue-router";
import store from "../store/store";
let Chushi = () =>
    import("@/components/chushi");
let Shouye = () =>
    import("@/components/shouye");
let Login = () =>
    import("@/components/login");
let wSzizhi = () =>
    import("@/components/wSzizhi");
let Index = () =>
    import("@/components/index");
let Sousuo = () =>
    import("@/components/sousuo");
let Sousuo1 = () =>
    import("@/components/Sousuo1");
let ShopDetails = () =>
    import("@/components/shopDetails");
let tetui = () =>
    import("@/components/tetui");
let Activement = () =>
    import("@/components/Activement");
let ShopDetailscoll = () =>
    import("@/components/ShopDetailscoll");
let ShopList = () =>
    import("@/components/shoplist/shopList"); //商品列表
let productlist = () =>
    import("@/components/shoplist/productlist"); //商品列表
let changeInfo = () =>
    import("@/components/changeInfo");
let ShopDetailsPL = () =>
    import("@/components/shopDetailsPL");
let GuoWuChe = () =>
    import("@/components/guoWuChe");
let GuoWuChe1 = () =>
    import("@/components/guoWuChe1");
let MyShop = () =>
    import("@/components/myShop");
let OrderList = () =>
    import("@/components/orderList");
let OrderListDetails = () =>
    import("@/components/orderListDetails");
let OrderListDetails1 = () =>
    import("@/components/orderListDetails1");
let GouwucheTJDD = () =>
    import("@/components/gouwucheTJDD");
let GuoWuCheDel = () =>
    import("@/components/guoWuCheDel");
let Register = () =>
    import("@/components/register");
let MyYHJ = () =>
    import("@/components/myYHJ");
let Openbank = () =>
    import("@/components/openbank");
let Zhong = () =>
    import("@/components/Zhong");
let game = () =>
    import("@/components/game"); //转盘FLactivities
let FLactivities = () =>
    import("@/components/FLactivities"); //分类活动
let ceshi = () =>
    import("@/components/ceshi"); //分类活动
let hdongy = () =>
    import("@/components/hdongy"); //分类活动
let broadcast = () =>
    import("@/components/broadcast"); //直播
let enterbroadcast = () =>
    import("@/components/enterbroadcast"); //直播KFservice
let KFservice = () =>
    import("@/components/KFservice");
let returnGoods = () =>
    import("@/components/returnGoods");
let returnGoods1 = () =>
    import("@/components/returnGoods1");
let returnGoods2 = () =>
    import("@/components/returnGoods2");
let refundInformation = () =>
    import("@/components/refundInformation");
let UserInfo = () =>
    import("@/components/userInfo");
let Address = () =>
    import("@/components/address");
let AddressUpdata = () =>
    import("@/components/addressUpdata");
let MySC = () =>
    import("@/components/mySC");
let ResetPassword = () =>
    import("@/components/resetPassword");
let GuoWuzhifu = () =>
    import("@/components/guoWuzhifu");
let OrderDetailsCZ = () =>
    import("@/components/orderDetailsCZ");
let Pingjia = () =>
    import("@/components/pingjia");

let LqYHJ = () =>
    import("@/components/lqYHJ");
let Ok = () =>
    import("@/components/ok");
let loginMima = () =>
    import("@/components/loginMima");
let loginYzm = () =>
    import("@/components/loginYzm");
let WJpassword = () =>
    import("@/components/WJpassword");
let addressUpdataX = () =>
    import("@/components/addressUpdataX");
let shezhi = () =>
    import("@/components/shezhi");
let huodong = () =>
    import("@/components/huodong");
let activDetails = () =>
    import("@/components/activDetails");
let activDetailsWarp = () =>
    import("@/components/activDetailsWarp");
let advertisement = () =>
    import("@/components/advertisement");
let purchase = () =>
    import("@/components/purchase");
let logistics = () =>
    import("@/components/logistics");
let lijiPay = () =>
    import("@/components/lijiPay");

let Hdong = () =>
    import("@/components/hdong");
let footprint = () =>
    import("@/components/footprint");
let Chgzhifu = () =>
    import("@/components/chgzhifu");
let Yinsi = () =>
    import("@/components/yinsi");
let Fuwu = () =>
    import("@/components/fuwu");
let Bangka = () =>
    import("@/components/bangka");
let Qrbangk = () =>
    import("@/components/qrbangk");
let videolist = () =>
    import("@/components/videolist");
let videochapter = () =>
    import("@/components/videochapter");
let videodetails = () =>
    import("@/components/videodetails");
let Merchant = () =>
    import("@/components/Merchant");
let a = () =>
    import("@/components/a");
let news = () =>
    import("@/components/news");
let newlist = () =>
    import("@/components/newlist");
let shopNotice = () =>
    import("@/components/shopNotice");
let newShopResgister = () =>
    import("@/components/newShopResgister");
let newShop = () =>
    import("@/components/newShop");
let banklist = () =>
    import("@/components/banklist");
let photocopy = () =>
    import("@/components/photocopy");
let openAccount = () =>
    import("@/components/openAccount");
let classify = () =>
    import("@/components/classify");
let classifys = () =>
    import("@/components/fenlei/classifys");
let oldclassify = () =>
    import("@/components/fenlei/oldclassify"); //shopActivDetail
let shopActivDetail = () =>
    import("@/components/shopActivDetail"); //
let shop = () =>
    import("@/components/shop/shop"); //
let shoplist = () =>
    import("@/components/shop/shoplist"); //
let collage = () =>
    import("@/components/collage");
let Invoice = () =>
    import("@/components/seeinvoice.vue");
let OfThePublic = () =>
    import("@/components/OfThePublic.vue");
let aboutUs = () =>
    import("@/components/aboutUs.vue");
Vue.use(Router);
const scrollBehavior = (to, from, savedPosition) => {
    if (savedPosition) {
        //保持原先的滚动位置
        store.commit("addCount", to.name);
        store.commit("delCount", from.name);
    }
};
const route = new Router({
    // mode: "history",
    scrollBehavior,
    routes: [{
        path: "/",
        name: "Chushi",
        component: Chushi,
        meta: {
            title: "首页",
            keepAlive: true // 需要缓存
        },
        children: [{
            path: "/",
            name: "Shouye",
            component: Shouye,
            meta: {
                title: "首页",
                keepAlive: true, // 需要缓存
            }
        },
        {
            path: "/classifys",
            name: "classifys",
            component: classifys,
            meta: {
                title: "分类",
                keepAlive: true, // 需要缓存
            },
            children: [{
                path: "",
                name: "oldclassify",
                component: oldclassify,
                meta: {
                    title: "分类",
                    keepAlive: true, // 需要缓存
                }
            }]
        },
        {
            path: "Index",
            name: "Index",
            component: Index,
            meta: {
                title: "分类",
                keepAlive: true, // 需要缓存
            }
        },
        {
            path: "huodong",
            name: "huodong",
            component: huodong,
            meta: {
                title: "活动",
                keepAlive: true, // 需要缓存
            }
        },
        {
            path: "GuoWuChe",
            name: "GuoWuChe",
            component: GuoWuChe,
            meta: {
                title: "购物车",
                keepAlive: false, // 需要缓存
            }
        },
        {
            path: "GuoWuChe1",
            name: "GuoWuChe1",
            component: GuoWuChe1,
            meta: {
                title: "购物车",
                keepAlive: true, // 不需要缓存
                isLogin: true,
            }
        },
        {
            path: "MyShop",
            name: "MyShop",
            component: MyShop,
            meta: {
                title: "我的商城",
                keepAlive: false,
                isLogin: true,
            }
        },
        {
            path: "/activDetails",
            name: "activDetails",
            component: activDetails,
            meta: {
                title: "活动页",
                keepAlive: true
            }
        },
        ]
    },
    {
        path: "/Sousuo",
        name: "Sousuo",
        component: Sousuo,
        meta: {
            title: "搜索",
            keepAlive: true
        }
    },
    {
        path: "/Sousuo1",
        name: "Sousuo1",
        component: Sousuo1,
        meta: {
            title: "更多商品",
            keepAlive: true
        }
    },

    {
        path: "/collage",
        name: "collage",
        component: collage,
        meta: {
            title: "拼团",
        }
    },
    {
        path: "/lijiPay",
        name: "lijiPay",
        component: lijiPay,
        meta: {
            title: "立即支付"
        }
    },
    {
        path: "/logistics",
        name: "logistics",
        component: logistics,
        meta: {
            title: "查看物流",
            isLogin: true,
        }
    },

    {
        path: "/activDetailsWarp",
        name: "activDetailsWarp",
        component: activDetailsWarp,
        meta: {
            title: "活动页",
            keepAlive: true,
        }
    },
    {
        path: "/advertisement",
        name: "advertisement",
        component: advertisement,
        meta: {
            title: "广告图"
        }
    },
    {
        path: "/purchase",
        name: "purchase",
        component: purchase,
        meta: {
            title: "限时抢购"
        }
    },

    {
        path: "/shezhi",
        name: "shezhi",
        component: shezhi,
        meta: {
            title: "设置"
        }
    },
    {
        path: "/addressUpdataX",
        name: "addressUpdataX",
        component: addressUpdataX,
        meta: {
            title: "新增收货人",
            isLogin: true,
        }
    },
    {
        path: "/WJpassword",
        name: "WJpassword",
        component: WJpassword,
        meta: {
            title: "找回密码"
        }
    },
    {
        path: "/loginYzm",
        name: "loginYzm",
        component: loginYzm,
        meta: {
            title: "验证码登录"
        }
    },
    {
        path: "/loginMima",
        name: "loginMima",
        component: loginMima,
        meta: {
            title: "账号密码登录"
        }
    },
    {
        path: "/ShopList",
        name: "ShopList",
        component: ShopList,
        meta: {
            // keepAlive: true
        },
        children: [{
            path: "",
            name: "productlist",
            component: productlist,
            meta: {
                keepAlive: true
            }
        }]
    },
    {
        path: "/changeInfo",
        name: "changeInfo",
        component: changeInfo,
        meta: {
            title: "信息编辑",
            isLogin: true,
        }
    },
    {
        path: "/Login",
        name: "Login",
        component: Login,
        meta: {
            title: "登录"
        }
    },
    {
        path: "/wSzizhi",
        name: "wSzizhi",
        component: wSzizhi,
        meta: {
            title: "上传资质信息",
            isLogin: true,
        }
    },
    {
        path: "/ShopDetails",
        name: "ShopDetails",
        component: ShopDetails,
        meta: {
            title: "商品详情",
            keepAlive: false // 不需要缓存
        }
    },
    {
        path: "/ShopDetailscoll",
        name: "ShopDetailscoll",
        component: ShopDetailscoll,
        meta: {
            title: "拼团商品详情",
            keepAlive: false // 不需要缓存
        }
    },
    {
        path: "/tetui",
        name: "tetui",
        component: tetui,
        meta: {
            title: "特推商品",
            keepAlive: false // 不需要缓存
        }
    },
    {
        path: "/Activement",
        name: "Activement",
        component: Activement,
        meta: {
            title: "特推商品活动图",
            keepAlive: false // 不需要缓存
        }
    },
    {
        path: "/ShopDetailsPL",
        name: "ShopDetailsPL",
        component: ShopDetailsPL,
        meta: {
            title: "评论"
        }
    },

    {
        path: "/OrderList",
        name: "OrderList",
        component: OrderList,
        meta: {
            title: "订单列表",
            keepAlive: true,
            isLogin: true,
        }
    },
    {
        path: "/OrderListDetails",
        name: "OrderListDetails",
        component: OrderListDetails,
        meta: {
            title: "订单详情",
            isLogin: true,
        }
    },
    {
        path: "/OrderListDetails1",
        name: "OrderListDetails1",
        component: OrderListDetails1,
        meta: {
            title: "订单详情",
            isLogin: true,

        }
    },
    {
        path: "/GouwucheTJDD",
        name: "GouwucheTJDD",
        component: GouwucheTJDD,
        meta: {
            title: "购物车订单提交",
            isLogin: true,

        }
    },
    {
        path: "/GuoWuCheDel",
        name: "GuoWuCheDel",
        component: GuoWuCheDel,
        meta: {
            title: "购物车商品删除",
            isLogin: true,
        }
    },
    {
        path: "/Register",
        name: "Register",
        component: Register,
        meta: {
            title: "注册"
        }
    },
    {
        path: "/MyYHJ",
        name: "MyYHJ",
        component: MyYHJ,
        meta: {
            title: "我的优惠",
            isLogin: true,
        }
    },
    {
        path: "/UserInfo",
        name: "UserInfo",
        component: UserInfo,
        meta: {
            title: "我的优惠",
            isLogin: true,
        }
    },
    {
        path: "/Address",
        name: "Address",
        component: Address,
        meta: {
            title: "我的地址",
            isLogin: true,
        }
    },
    {
        path: "/AddressUpdata",
        name: "AddressUpdata",
        component: AddressUpdata,
        meta: {
            title: "地址编辑",
            isLogin: true,
        }
    },
    {
        path: "/MySC",
        name: "MySC",
        component: MySC,
        meta: {
            title: "我的收藏",
            isLogin: true,
        }
    },
    {
        path: "/ResetPassword",
        name: "ResetPassword",
        component: ResetPassword,
        meta: {
            title: "修改密码"
        }
    },
    {
        path: "/GuoWuzhifu",
        name: "GuoWuzhifu",
        component: GuoWuzhifu,
        meta: {
            title: "支付",
            isLogin: true,
        }
    },
    {
        path: "/OrderDetailsCZ",
        name: "OrderDetailsCZ",
        component: OrderDetailsCZ,
        meta: {
            title: "订单操作",
            isLogin: true,
        }
    },
    {
        path: "/Pingjia",
        name: "Pingjia",
        component: Pingjia,
        meta: {
            title: "评价"
        }
    },
    {
        path: "/LqYHJ",
        name: "LqYHJ",
        component: LqYHJ,
        meta: {
            title: "领取优惠券",
            isLogin: true,
        }
    },
    {
        path: "/Ok",
        name: "Ok",
        component: Ok,
        meta: {
            title: "支付成功",
            isLogin: true,
        }
    },
    {
        path: "/Merchant",
        name: "Merchant",
        component: Merchant,
        meta: {
            title: "商铺",
            keepAlive: true
        }
    },
    {
        path: "/shop",
        name: "shop",
        component: shop,
        meta: {
            title: "商铺列表",
        },
        children: [{
            path: "",
            name: "shoplist",
            component: shoplist,
            meta: {
                title: "商铺列表",
            },
        }]
    },
    {
        path: "/Hdong",
        name: "hdong",
        component: Hdong,
        meta: {
            title: "活动"
        }
    },
    {
        path: "/Chgzhifu",
        name: "chgzhifu",
        component: Chgzhifu,
        meta: {
            title: "支付成功",
            isLogin: true,
        }
    },
    {
        path: "/Yinsi",
        name: "yinsi",
        component: Yinsi,
        meta: {
            title: "隐私协议",
        }
    },
    {
        path: "/Fuwu",
        name: "fuwu",
        component: Fuwu,
        meta: {
            title: "服务协议"
        }
    },
    {
        path: "/Bangka",
        name: "bangka",
        component: Bangka,
        meta: {
            title: "银行卡绑定"
        }
    },
    {
        path: "/Qrbangk",
        name: "qrbangk",
        component: Qrbangk,
        meta: {
            title: "确认绑卡"
        }
    },
    {
        path: "/openbank",
        name: "openbank",
        component: Openbank,
        meta: {
            title: "开户申请"
        }
    },
    {
        path: "/Zhong",
        name: "Zhong",
        component: Zhong
    },
    {
        path: "/game",
        name: "game",
        component: game,
        meta: {
            title: "抽奖活动"
        }
    },
    {
        path: "/FLactivities",
        name: "FLactivities",
        component: FLactivities,
        meta: {
            title: "开户申请"
        }
    },
    {
        path: "/ceshi",
        name: "ceshi",
        component: ceshi,
        meta: {
            title: "客户"
        }
    },
    {
        path: "/videolist",
        name: "videolist",
        component: videolist,
        meta: {
            title: "视频学习"
        }
    },
    {
        path: "/videochapter",
        name: "videochapter",
        component: videochapter,
        meta: {
            title: "视频学习章节"
        }
    },

    {
        path: "/videodetails",
        name: "videodetails",
        component: videodetails,
        meta: {
            title: "视频学习详情"
        }
    },

    {
        path: "/hdongy",
        name: "hdongy",
        component: hdongy,
        meta: {
            title: "活动"
        }
    },
    {
        path: "/footprint",
        name: "footprint",
        component: footprint,
        meta: {
            title: "足迹"
        }
    },

    {
        path: "/broadcast",
        name: "broadcast",
        component: broadcast,
        meta: {
            title: "直播"
        }
    },

    {
        path: "/enterbroadcast",
        name: "enterbroadcast",
        component: enterbroadcast,
        meta: {
            title: "直播间"
        }
    },

    {
        path: "/KFservice",
        name: "KFservice",
        component: KFservice,
        meta: {
            title: "客户服务"
        }
    },

    {
        path: "/returnGoods",
        name: "returnGoods",
        component: returnGoods,
        meta: {
            title: "申请退款",
            isLogin: true,
        }
    },
    {
        path: "/returnGoods1",
        name: "returnGoods1",
        component: returnGoods1,
        meta: {
            title: "申请退货退款",
            isLogin: true,
        }
    },
    {
        path: "/returnGoods2",
        name: "returnGoods2",
        component: returnGoods2,
        meta: {
            title: "申请退货退款",
            isLogin: true,
        }
    },
    {
        path: "/refundInformation",
        name: "refundInformation",
        component: refundInformation,
        meta: {
            title: "退款详情",
            isLogin: true,
        }
    },
    {
        path: "/a",
        name: "a",
        component: a,
        meta: {
            title: "退款详情"
        }
    },
    {
        path: "/news",
        name: "news",
        component: news,
        meta: {
            title: "新闻"
        }
    },
    {
        path: "/newlist",
        name: "newlist",
        component: newlist,
        meta: {
            title: "新闻列表"
        }
    },
    {
        path: "/shopNotice",
        name: "shopNotice",
        component: shopNotice,
        meta: {
            title: "公告信息"
        }
    },
    {
        path: "/newShop",
        name: "newShop",
        component: newShop,
        meta: {
            title: "新品登记",
            isLogin: true,
        }
    },
    {
        path: "/newShopResgister",
        name: "newShopResgister",
        component: newShopResgister,
        meta: {
            title: "新品登记",
            isLogin: true,
        }
    },
    {
        path: "/banklist",
        name: "banklist",
        component: banklist,
        meta: {
            title: "绑卡列表"
        }
    },
    {
        path: "/photocopy",
        name: "photocopy",
        component: photocopy,
        meta: {
            title: "采集影件"
        }
    },
    {
        path: "/openAccount",
        name: "openAccount",
        component: openAccount,
        meta: {
            title: "企业绑卡"
        }
    },
    {
        path: "/classify",
        name: "classify",
        component: classify,
        meta: {
            title: "",
            keepAlive: true
        }
    },
    {
        path: "/shopActivDetail",
        name: "shopActivDetail",
        component: shopActivDetail,
        meta: {
            title: "",
        }
    },
    {
        path: "/seeInvoice",
        name: "seeInvoice",
        component: Invoice,
        meta: {
            title: "查看发票",
        }
    }, {
        path: "/OfThePublic",
        name: "OfThePublic",
        component: OfThePublic,
        meta: {
            title: "对公支付",
        }
    },{
        path: "/aboutUs",
        name: "aboutUs",
        component: aboutUs,
        meta: {
            title: "关于我们",
        }
    },

    ]
})
route.beforeEach((to, from, next) => {
    if (to.name === "Shouye") store.state.tabNum = 0
    if (to.name === "Index") store.state.tabNum = 1
    if (to.name === "activDetails") store.state.tabNum = 2
    if (to.name === "GuoWuChe") store.state.tabNum = 3
    if (to.name === "MyShop") store.state.tabNum = 4
    store.commit("tabs", {
        key: "to",
        value: to
    })
    store.commit("tabs", {
        key: "from",
        value: from
    })
    if (from.name == 'Shouye' || from.name == 'activDetails' || from.name == "Index" || from.name == "MyShop" || from.name == "loginMima") {
        localStorage.setItem("keepAlive", true)
    } else {
        localStorage.removeItem("keepAlive")
    }
    if (to.name === "activDetails" || to.name === "GuoWuChe" || to.name === "MyShop" || to.meta.isLogin) {
        if (JSON.parse(localStorage.getItem("user_xinxi")) != null) {
            next()
        } else {
            route.push(`/loginMima`)
            next();
        }
    } else {
        next();
    }

})
export default route;


// WEBPACK FOOTER //
// ./src/router/index.js